/** @format */

import Skeleton from '@mui/material/Skeleton';
import { useTranslation } from 'react-i18next';

const skeletonBar = { backgroundColor: 'rgba(0, 31, 55, 0.08)' };
const ROW_COUNT = 6;

function TopicAdminRowSkeleton() {
  return (
    <div
      className="administration-topics-page__data-row administration-topics-page__data-row--skeleton"
      aria-hidden="true">
      <div className="administration-topics-page__cell administration-topics-page__cell--name">
        <Skeleton variant="text" width="92%" height={22} style={skeletonBar} />
      </div>
      <div className="administration-topics-page__cell administration-topics-page__cell--display">
        <Skeleton variant="text" width="78%" height={20} style={skeletonBar} />
      </div>
      <div className="administration-topics-page__cell administration-topics-page__cell--brand">
        <Skeleton variant="text" width={56} height={20} style={skeletonBar} />
      </div>
      <div className="administration-topics-page__cell administration-topics-page__cell--actions">
        <div className="administration-topics-page__row-actions administration-topics-page__row-actions--skeleton">
          <Skeleton variant="rectangular" width={36} height={36} style={skeletonBar} />
          <Skeleton variant="rectangular" width={36} height={36} style={skeletonBar} />
        </div>
      </div>
    </div>
  );
}

export default function TopicsAdminPageSkeleton() {
  const { t } = useTranslation();

  return (
    <div className="administration-topics-page__scroll" role="status" aria-live="polite" aria-busy="true">
      <span className="visually-hidden">{t('common.loading')}</span>
      <div
        className="administration-topics-page__sheet administration-topics-page__sheet--skeleton administration-topics-page__sheet--vt"
        role="presentation">
        <div className="administration-topics-page__mobile-labels" aria-hidden="true">
          <Skeleton variant="text" width={80} height={18} style={skeletonBar} />
          <Skeleton variant="text" width={56} height={16} style={skeletonBar} />
        </div>
        <div className="administration-topics-page__header-group" aria-hidden="true">
          <div className="administration-topics-page__header-row administration-topics-page__header-row--skeleton">
            <div className="administration-topics-page__header-cell">
              <Skeleton variant="text" width="50%" height={18} style={skeletonBar} />
            </div>
            <div className="administration-topics-page__header-cell">
              <Skeleton variant="text" width="45%" height={18} style={skeletonBar} />
            </div>
            <div className="administration-topics-page__header-cell">
              <Skeleton variant="text" width={40} height={18} style={skeletonBar} />
            </div>
            <div className="administration-topics-page__header-cell administration-topics-page__header-cell--actions">
              <Skeleton variant="rectangular" width={72} height={18} style={skeletonBar} />
            </div>
          </div>
        </div>
        <div className="administration-topics-page__body-group">
          {Array.from({ length: ROW_COUNT }).map((_, index) => (
            <TopicAdminRowSkeleton key={index} />
          ))}
        </div>
      </div>
    </div>
  );
}
